import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import "./PaymentPending.css";

export default function PaymentPending() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("order_id");

  const [orderStatus, setOrderStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(null);

  useEffect(() => {
    if (!orderId) return;
    setLoading(true);
    setFetchError(null);
    // initial fetch; you can add polling if desired
    fetch(`/api/orders/${orderId}/status`)
      .then((res) => {
        if (!res.ok) throw new Error("وضعیت سفارش قابل دریافت نیست");
        return res.json();
      })
      .then((data) => setOrderStatus(data))
      .catch((err) => setFetchError(err.message))
      .finally(() => setLoading(false));
  }, [orderId]);

  return (
    <div className="status-page">
      <div className="status-card pending">
        <div className="status-icon" aria-hidden>
          {/* subtle spinner-like circle */}
          <svg width="60" height="60" viewBox="0 0 50 50" fill="none">
            <circle cx="25" cy="25" r="20" stroke="#f6ad55" strokeWidth="4" fill="#fffaf0" />
            <path d="M25 5 A20 20 0 0 1 45 25" stroke="#ed8936" strokeWidth="4" strokeLinecap="round"/>
          </svg>
        </div>

        <h1 className="status-title">پرداخت در حال بررسی</h1>
        <p className="status-message">
          پرداخت شما انجام شده است اما در حال حاضر وضعیت آن در حال تأیید است. لطفاً چند دقیقه صبر کنید.
        </p>

        <div className="status-details">
          {orderId && <div><strong>شماره سفارش:</strong> <span>{orderId}</span></div>}
          {loading && <div className="small-muted">در حال دریافت وضعیت...</div>}
          {fetchError && <div className="small-muted error">{fetchError}</div>}
          {orderStatus && (
            <div className="order-info">
              <div><strong>وضعیت سفارش:</strong> <span>{orderStatus.status}</span></div>
              {orderStatus.transaction_id && <div><strong>کد تراکنش:</strong> <span>{orderStatus.transaction_id}</span></div>}
            </div>
          )}
        </div>

        <div className="status-actions">
          <Link to={`/orders/${orderId}`} className="btn">مشاهده سفارش</Link>
          <Link to="/support" className="btn btn-outline">تماس با پشتیبانی</Link>
        </div>
      </div>
    </div>
  );
}
